import { PaymentMethod } from 'src/contexto/types'
import { apiV2 } from '../api'
import { httpRequest } from '../http-request'

export const getPaymentMethods = async () => {
  const response = await httpRequest<{ data: PaymentMethod[] }>({
    instance: apiV2,
    endpoint: '/canais/formas-pagamento',
    method: 'GET',
  })
  return response.data?.data ?? []
}
